/* ============================================
   MEGA MENU JS - JustForFunFlags
   Phase 2: Desktop & Mobile interactions
   UPDATED: Hover for desktop
   ============================================ */

(function() {
  'use strict';

  // ==================== CONFIGURATION ====================
  const CONFIG = {
    selectors: {
      container: '.mega-menu-container',
      nav: '.mega-menu-nav',
      navItem: '.mega-menu-nav__item',
      navLink: '.mega-menu-nav__link',
      dropdown: '.mega-menu-dropdown',
      scrollContainer: '.mega-menu-scroll',
      scrollHint: '.mega-menu-scroll-hint',
      sectionTitle: '.mega-menu-section__title',
      sectionList: '.mega-menu-section__list',
      // Mobile
      toggle: '.nav-trigger',
      mobileMenu: '.mega-menu-mobile',
      mobileLink: '.mega-menu-mobile__link',
      mobileSubmenu: '.mega-menu-mobile__submenu',
      columnHeader: '.mega-menu-mobile__column-header',
      columnSection: '.mega-menu-mobile__section',
      sectionHeader: '.mega-menu-mobile__section-header',
      sectionLinks: '.mega-menu-mobile__links'
    },
    classes: {
      active: 'is-active',
      open: 'is-open',
      expanded: 'is-expanded',
      collapsed: 'is-collapsed',
      hidden: 'is-hidden'
    },
    breakpoint: 768,
    hoverDelay: 150,      // Delay before opening on hover
    closeDelay: 300       // Delay before closing when mouse leaves
  };

  let hoverTimeout;
  let closeTimeout;

  // ==================== DESKTOP: MENU TOGGLE ====================
  function initDesktopMenu() {
    const navLinks = document.querySelectorAll(CONFIG.selectors.navLink);
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    navLinks.forEach(link => {
      if (isTouchDevice) {
        // Touch devices: click to toggle
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const menuId = this.getAttribute('data-menu');
          toggleDesktopMenu(menuId, this);
        });
      } else {
        // Desktop: hover to open
        link.addEventListener('mouseenter', function() {
          clearTimeout(closeTimeout);
          const menuId = this.getAttribute('data-menu');
          
          hoverTimeout = setTimeout(() => {
            openDesktopMenu(menuId, this);
          }, CONFIG.hoverDelay);
        });

        link.addEventListener('mouseleave', function() {
          clearTimeout(hoverTimeout);
        });

        // Also prevent default click behavior
        link.addEventListener('click', function(e) {
          e.preventDefault();
        });
      }
    });

    // Handle dropdown hover
    const dropdowns = document.querySelectorAll(CONFIG.selectors.dropdown);
    dropdowns.forEach(dropdown => {
      if (!isTouchDevice) {
        dropdown.addEventListener('mouseenter', function() {
          clearTimeout(closeTimeout);
        });

        dropdown.addEventListener('mouseleave', function() {
          closeTimeout = setTimeout(() => {
            closeAllDesktopMenus();
          }, CONFIG.closeDelay);
        });
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      const container = document.querySelector(CONFIG.selectors.container);
      if (container && !container.contains(e.target)) {
        closeAllDesktopMenus();
      }
    });

    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAllDesktopMenus();
      }
    });

    // Handle nav container mouse leave
    const nav = document.querySelector(CONFIG.selectors.nav);
    if (nav && !isTouchDevice) {
      nav.addEventListener('mouseleave', function() {
        closeTimeout = setTimeout(() => {
          closeAllDesktopMenus();
        }, CONFIG.closeDelay);
      });
    }
  }

  function toggleDesktopMenu(menuId, clickedLink) {
    const dropdown = document.getElementById('mega-menu-' + menuId);
    const isOpen = dropdown && dropdown.classList.contains(CONFIG.classes.active);

    // Close all menus first
    closeAllDesktopMenus();

    // If wasn't open, open it
    if (!isOpen && dropdown) {
      dropdown.classList.add(CONFIG.classes.active);
      clickedLink.classList.add(CONFIG.classes.active);
      
      // Show scroll hint if scrollable
      checkScrollHint(dropdown);
    }
  }

  function openDesktopMenu(menuId, link) {
    closeAllDesktopMenus();
    
    const dropdown = document.getElementById('mega-menu-' + menuId);
    if (dropdown) {
      dropdown.classList.add(CONFIG.classes.active);
      link.classList.add(CONFIG.classes.active);
      checkScrollHint(dropdown);
    }
  }

  function closeAllDesktopMenus() {
    const dropdowns = document.querySelectorAll(CONFIG.selectors.dropdown);
    const links = document.querySelectorAll(CONFIG.selectors.navLink);
    
    dropdowns.forEach(d => d.classList.remove(CONFIG.classes.active));
    links.forEach(l => l.classList.remove(CONFIG.classes.active));
  }

  // ==================== DESKTOP: SCROLL HINT ====================
  function checkScrollHint(dropdown) {
    const scrollContainer = dropdown.querySelector(CONFIG.selectors.scrollContainer);
    const scrollHint = dropdown.querySelector(CONFIG.selectors.scrollHint);
    
    if (scrollContainer && scrollHint) {
      // Show hint if content is scrollable
      if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
        scrollHint.classList.remove(CONFIG.classes.hidden);
        
        // Hide hint after user scrolls
        scrollContainer.addEventListener('scroll', function hideHint() {
          scrollHint.classList.add(CONFIG.classes.hidden);
          scrollContainer.removeEventListener('scroll', hideHint);
        }, { once: true });
        
        // Auto-hide after 3 seconds
        setTimeout(() => {
          scrollHint.classList.add(CONFIG.classes.hidden);
        }, 3000);
      } else {
        scrollHint.classList.add(CONFIG.classes.hidden);
      }
    }
  }

  // ==================== DESKTOP: COLLAPSIBLE SECTIONS ====================
  function initCollapsibleSections() {
    const sectionTitles = document.querySelectorAll(CONFIG.selectors.sectionTitle + '[data-toggle]');
    
    sectionTitles.forEach(title => {
      title.addEventListener('click', function() {
        const listId = this.getAttribute('data-toggle');
        const list = document.getElementById(listId);
        const arrow = this.querySelector('.arrow');
        
        if (list) {
          const isCollapsed = list.classList.contains(CONFIG.classes.collapsed);
          
          if (isCollapsed) {
            list.classList.remove(CONFIG.classes.collapsed);
            this.classList.add(CONFIG.classes.expanded);
            if (arrow) arrow.textContent = '▼';
          } else {
            list.classList.add(CONFIG.classes.collapsed);
            this.classList.remove(CONFIG.classes.expanded);
            if (arrow) arrow.textContent = '▶';
          }
        }
      });
    });
  }

  // ==================== MOBILE: HAMBURGER TOGGLE ====================
  function initMobileMenu() {
    const toggle = document.querySelector(CONFIG.selectors.toggle);
    const mobileMenu = document.querySelector(CONFIG.selectors.mobileMenu);
    
    if (toggle && mobileMenu) {
      toggle.addEventListener('click', function() {
        this.classList.toggle(CONFIG.classes.open);
        mobileMenu.classList.toggle(CONFIG.classes.open);
        
        // Prevent body scroll when menu is open
        document.body.style.overflow = mobileMenu.classList.contains(CONFIG.classes.open) ? 'hidden' : '';
      });
    }

    // Initialize accordion levels
    initMobileAccordion();
  }

  // ==================== MOBILE: ACCORDION ====================
  function initMobileAccordion() {
    // Level 1: Main categories (Garden Flags, House Flags, etc.)
    const mobileLinks = document.querySelectorAll(CONFIG.selectors.mobileLink);
    mobileLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        toggleMobileLevel(this, CONFIG.selectors.mobileSubmenu);
      });
    });

    // Level 2: Columns (Best Sellers, Seasons, etc.)
    const columnHeaders = document.querySelectorAll(CONFIG.selectors.columnHeader);
    columnHeaders.forEach(header => {
      header.addEventListener('click', function() {
        toggleMobileLevel(this, CONFIG.selectors.columnSection);
      });
    });

    // Level 3: Sections (Spring, Summer, etc.)
    const sectionHeaders = document.querySelectorAll(CONFIG.selectors.sectionHeader);
    sectionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        toggleMobileLevel(this, CONFIG.selectors.sectionLinks);
      });
    });
  }

  function toggleMobileLevel(trigger, submenuSelector) {
    const isActive = trigger.classList.contains(CONFIG.classes.active);
    const parent = trigger.parentElement;
    // Submenu is the next sibling of trigger (not parent's next sibling)
    const submenu = trigger.nextElementSibling;
    const arrow = trigger.querySelector('.arrow');

    // Close ALL sibling submenus at the same level
    const siblings = parent.parentElement.children;
    Array.from(siblings).forEach(sibling => {
      // Skip the current parent
      if (sibling === parent) return;
      
      // Find trigger in this sibling
      const siblingTrigger = sibling.querySelector('.' + trigger.className.split(' ')[0]);
      
      if (siblingTrigger && siblingTrigger !== trigger) {
        siblingTrigger.classList.remove(CONFIG.classes.active);
        const siblingArrow = siblingTrigger.querySelector('.arrow');
        if (siblingArrow) siblingArrow.textContent = '▼';
        
        // Close the submenu (next sibling of the trigger)
        const siblingSubmenu = siblingTrigger.nextElementSibling;
        if (siblingSubmenu) {
          siblingSubmenu.classList.remove(CONFIG.classes.open);
        }
      }
    });

    // Toggle current
    if (submenu) {
      if (isActive) {
        trigger.classList.remove(CONFIG.classes.active);
        submenu.classList.remove(CONFIG.classes.open);
        if (arrow) arrow.textContent = '▼';
      } else {
        trigger.classList.add(CONFIG.classes.active);
        submenu.classList.add(CONFIG.classes.open);
        if (arrow) arrow.textContent = '▲';
      }
    }
  }

  // ==================== MOBILE: CLOSE ON RESIZE ====================
  function initResizeHandler() {
    let resizeTimer;
    
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth > CONFIG.breakpoint) {
          // Close mobile menu when resizing to desktop
          const toggle = document.querySelector(CONFIG.selectors.toggle);
          const mobileMenu = document.querySelector(CONFIG.selectors.mobileMenu);
          
          if (toggle) toggle.classList.remove(CONFIG.classes.open);
          if (mobileMenu) mobileMenu.classList.remove(CONFIG.classes.open);
          document.body.style.overflow = '';
        }
      }, 250);
    });
  }

  // ==================== ACCESSIBILITY ====================
  function initAccessibility() {
    // Add keyboard navigation for desktop menu
    const navLinks = document.querySelectorAll(CONFIG.selectors.navLink);
    
    navLinks.forEach((link, index) => {
      link.setAttribute('tabindex', '0');
      
      link.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
        
        // Arrow key navigation
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const next = navLinks[index + 1] || navLinks[0];
          next.focus();
        }
        
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prev = navLinks[index - 1] || navLinks[navLinks.length - 1];
          prev.focus();
        }
      });
    });

    // Mobile menu keyboard support
    const toggle = document.querySelector(CONFIG.selectors.toggle);
    if (toggle) {
      toggle.setAttribute('aria-label', 'Toggle navigation menu');
      toggle.setAttribute('aria-expanded', 'false');
      
      toggle.addEventListener('click', function() {
        const isOpen = this.classList.contains(CONFIG.classes.open);
        this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  }

  // ==================== AUTO-EXPAND CURRENT SEASON ====================
  // Reads data-season and data-holiday from the Liquid-rendered #mega-menu-auto div
  // and expands the matching sections in both desktop and mobile menus.

  function expandDesktopSection(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.remove(CONFIG.classes.collapsed);
    const header = document.querySelector('[data-toggle="' + id + '"]');
    if (header) {
      header.classList.add(CONFIG.classes.expanded);
      const arrow = header.querySelector('.arrow');
      if (arrow) arrow.textContent = '▼';
    }
  }

  function collapseDesktopSection(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.add(CONFIG.classes.collapsed);
    const header = document.querySelector('[data-toggle="' + id + '"]');
    if (header) {
      header.classList.remove(CONFIG.classes.expanded);
      const arrow = header.querySelector('.arrow');
      if (arrow) arrow.textContent = '▶';
    }
  }

  function autoExpandCurrentSeason() {
    const meta = document.getElementById('mega-menu-auto');
    if (!meta) return;

    const season  = meta.dataset.season;   // e.g. 'summer'
    const holiday = meta.dataset.holiday;  // e.g. 'summer-hol' or ''

    const seasons  = ['spring', 'summer', 'fall', 'winter'];
    const holidays = ['spring-hol', 'summer-hol', 'fall-hol', 'winter-hol'];
    const prefixes = ['gf', 'hf']; // garden flags, house flags

    prefixes.forEach(prefix => {
      // Collapse all seasons, expand the current one
      seasons.forEach(s => collapseDesktopSection(prefix + '-' + s));
      expandDesktopSection(prefix + '-' + season);

      // Collapse all holidays, expand the current one if set
      holidays.forEach(h => collapseDesktopSection(prefix + '-' + h));
      if (holiday) expandDesktopSection(prefix + '-' + holiday);
    });

    // ── Mobile: auto-open the "Seasons" column for Garden & House Flags ──
    // Find all mobile section headers that contain the current season text
    // and programmatically open them so the user sees the right section expanded.
    autoExpandMobileSeason(season, holiday);
  }

  function autoExpandMobileSeason(season, holiday) {
    // Map season/holiday key → display text to match against button text
    const seasonLabels = {
      'spring'     : 'Spring',
      'summer'     : 'Summer',
      'fall'       : 'Fall',
      'winter'     : 'Winter'
    };
    const holidayLabels = {
      'spring-hol' : 'Spring Holidays',
      'summer-hol' : 'Summer Holidays',
      'fall-hol'   : 'Fall Holidays',
      'winter-hol' : 'Winter Holidays'
    };

    const targetSeason  = seasonLabels[season]  || '';
    const targetHoliday = holidayLabels[holiday] || '';

    // Find mobile section headers that match and open their link list
    const sectionHeaders = document.querySelectorAll(CONFIG.selectors.sectionHeader);
    sectionHeaders.forEach(header => {
      const text = header.textContent.trim().replace(/[▼▶▲]/g, '').trim();
      if (text === targetSeason || (targetHoliday && text === targetHoliday)) {
        const links = header.nextElementSibling;
        if (links && !links.classList.contains(CONFIG.classes.open)) {
          header.classList.add(CONFIG.classes.active);
          links.classList.add(CONFIG.classes.open);
          const arrow = header.querySelector('.arrow');
          if (arrow) arrow.textContent = '▲';
        }
      }
    });
  }

  // ==================== INITIALIZATION ====================
  function init() {
    // Wait for DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  }

  // Get all close icons
  const closeIcons = document.querySelectorAll('.close-icon-new');

  closeIcons.forEach(closeIcon => {
    closeIcon.addEventListener('click', function(event) {
      event.preventDefault();
     
      // Remove is-open class from mega-menu-mobile
      const megaMenu = document.getElementById('mega-menu-mobile');
      if (megaMenu) {
        megaMenu.classList.remove('is-open');
      }
      document.body.classList.remove('off-canvas-body');

      // Remove overflow from body
      document.body.style.overflow = '';
    });
  });

  function initAll() {
    const container = document.querySelector(CONFIG.selectors.container);
    
    if (!container) {
      console.warn('Mega Menu: Container not found');
      return;
    }

    initDesktopMenu();
    initCollapsibleSections();
    initMobileMenu();
    initResizeHandler();
    initAccessibility();
    autoExpandCurrentSeason(); // ← auto-expand season/holiday on load

    console.log('Mega Menu: Initialized with hover functionality');
  }

  // Start
  init();

})();